var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3C1.89543 3 1 3.89543 1 5V11C1 12.1046 1.89543 13 3 13H8.5C9.60457 13 10.5 12.1046 10.5 11V5C10.5 3.89543 9.60457 3 8.5 3H3Z",
    fill: "#818385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2929 12.5L11.5 10.7071V5.29287L13.2929 3.49998C13.9229 2.87001 15 3.31618 15 4.20708V11.7929C15 12.6838 13.9229 13.1299 13.2929 12.5Z",
    fill: "#818385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.74d33847e0a65f43548b2b59a06b83e2.svg";
export { ForwardRef as ReactComponent };